import type { ChangeEvent } from 'react';

import { useMemo, useCallback } from 'react';

export function useCommonInputProps() {
  // Handle logic for Enter key press
  const handleKeyDown = useCallback(
    (callback: VoidFunction) => (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        callback();
      }
    },
    []
  );

  const handleChange = useCallback(
    (callback: (value: string) => void) => (e: ChangeEvent<HTMLInputElement>) => {
      e.preventDefault();
      callback(e.target.value);
    },
    []
  );

  const trimValue = useCallback((value: string) => value.trim(), []);

  const commonProps = useMemo(
    () => ({
      maxRows: 5,
      multiline: true,
      'aria-label': 'chat input box',
      'data-testid': 'chat-input-box',
      fullWidth: true,
      sx: {
        '& .MuiInputBase-input': {
          fontSize: '1rem',
          alignSelf: 'center',
          py: '4px',
        },
        alignItems: 'flex-end',
      },
    }),
    []
  );

  return {
    commonProps,
    handleKeyDown,
    handleChange,
    trimValue,
  };
}
